module.exports = __webpack_public_path__ + "img/slide6-768.58b601a2.png";